import Config from 'src/Config';

const pharmacyItems = [
  {
    title: 'Name',
    key: 'pharmacyId.name',
  },
  {
    title: 'Address',
    key: 'pharmacyId.address',
  },
  {
    title: 'City',
    key: 'pharmacyId.city',
  },
  {
    title: 'State',
    key: 'pharmacyId.state',
  },
  {
    title: 'Zip Code',
    key: 'pharmacyId.zipCode',
  },
  {
    title: 'Phone Number',
    key: 'pharmacyId.phoneNumber',
  },
  {
    title: 'Fax Number',
    key: 'pharmacyId.faxNumber',
  },
];

const prescriberItems = [
  {
    title: 'First Name',
    key: 'prescriberId.firstName',
  },
  {
    title: 'Last Name',
    key: 'prescriberId.lastName',
  },
  {
    title: 'NPI',
    key: 'prescriberId.NPI',
  },
  {
    title: 'Phone Number',
    key: 'prescriberId.phoneNumber',
  },
  {
    title: 'Fax Number',
    key: 'prescriberId.faxNumber',
  },
];

const medicationItems = [
  {
    title: 'Drug Name',
    key: 'drugName',
  },
  {
    title: 'Drug ID',
    key: 'drugId',
  },
  {
    title: 'Dose',
    key: 'dose',
  },
  {
    title: 'Frequency',
    key: 'frequency',
  },
  {
    title: 'Direction',
    key: 'direction',
  },
  {
    title: 'Fill Date',
    key: 'fillDate',
    type: 'date',
    format: Config.dateFormat,
  },
  {
    title: 'Quantity',
    key: 'quantity',
  },
  {
    title: 'Refill Quantity',
    key: 'refillQuantity',
  },
  {
    title: 'Days Supply',
    key: 'daysSupply',
  },
  {
    title: 'Prescription Number',
    key: 'prescriptionNumber',
  },
];
export const sectionList = [
  {
    title: 'Pharmacy',
    items: pharmacyItems,
  },
  {
    title: 'Prescriber',
    items: prescriberItems,
  },
  {
    title: 'Medication',
    items: medicationItems,
  },
];
